import Vue from 'vue';
import VueSanitize from 'vue-sanitize';

// NOTE: we allow more tags than the Desk itself because it's supposed to be used along with the rich text editor component
Vue.use(VueSanitize, {
  allowedTags: ['span', 'br', 'a', 'p', 'ul', 'li'],
  allowedAttributes: { span: ['class'], a: ['href', 'target'] },
});
